//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {
  },
  data () {
    return {
      // scanConfig: {
      //   btnL: {text: '返回', action: () => this.$router.go(-1)},
      //   desc: '扫一扫急速入库'
      // }
      isScanShow: true,
    }
  },
  props: ['config'],
  computed: {
    arrowDownPanelClass () {
      switch (this.isScanShow) {
        case true:
        return 'transition-slide-in';
        case false:
        return 'transition-slide-out'
      }
    },
    arrowUpPanelClass () {
      switch (this.isScanShow) {
        case true:
        return 'transition-slide-out';
        case false:
        return 'transition-slide-in'
      }
    }
  },
  methods: {
    scanCode () {
      mpvue.scanCode()
    },
    switchScan () {
      this.isScanShow = !this.isScanShow
    },
    onTapBtnLeft () {
      this.config.btnL.action()
    },
    onTapBtnRight () {
      this.config.btnR.action()
    }
  },
  onUnload () {
    this.isScanShow = true
  }
}
